import { IBasePickerSuggestionsProps, ITag } from '@fluentui/react';

//models
import { Contract } from "../../../../models/Entities/Contracts/Contract";
import { ContractBranch } from "../../../../models/Entities/Contracts/ContractBranch";
import { ErrorType } from "../../../../models/HttpError";

// stores
import * as ContractBranchStore from '../../../../redux/middleware/ContractBranchsMiddleware';
import * as ContractStore from '../../../../redux/middleware/ContractMiddleware';
import * as ContractAddendumStore from '../../../../redux/middleware/ContractAddendum.Middleware';

// common functions
import * as Functions from '../../../../functions/common'

//State
import { AppState } from "../../../../redux/reducers";


interface IProps {
  ContractId: number;
  AddendumId?: number;
  onSelectedContractBranch: (branches: ContractBranch[]) => void;
  ContractBranchesSelected: Array<number | string | ContractBranch> | undefined;
  MultiselectEnable: boolean;
  noteText?: string;
}

interface ConnectedProps {
  isLoading: boolean;
  isUpdating: boolean;
  isUpdatedSuccessfully: boolean;
  isLoadingSuccessfully: boolean;
  failOnUpdating: boolean;
  failOnLoading: boolean;
  error: ErrorType | undefined;
  Contract: Contract | undefined;
  ContractBranches: ContractBranch[];
}

interface DispatchProps {
  GetContractById: typeof ContractStore.actionCreators.GetContractById;
  GetAllContractsBranchs: typeof ContractBranchStore.actionCreators.GetAllContractsBranchs;
  GetContractAddendumsByContractId: typeof ContractAddendumStore.actionCreators.GetContractAddendumsByContractId;
}

export type Props = IProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => {

  const auxContract = state.Contract?.list?.find((item: Contract) => item.id === ownProps.ContractId) || undefined;

  let effectiveAddendumId = ownProps.AddendumId;
  
  if (auxContract?.addendums?.length && (ownProps.AddendumId === undefined || ownProps.AddendumId === null)) {
    // get current addendum (the active one)
    const currentAddendum = auxContract.addendums.find((item) => item.isActive);
    effectiveAddendumId = currentAddendum?.id;
  }

  const auxAddendum = auxContract?.addendums?.find((item) => item.id === effectiveAddendumId) || undefined;

  return {
    isLoading: auxAddendum?.isGettingContractBranches || state.ContractBranch?.isLoadingAll || false,
    isUpdating: state.ContractBranch?.isLoadingAll || false,
    isUpdatedSuccessfully: state.ContractBranch?.successLoadingAll || false,
    isLoadingSuccessfully: auxAddendum?.isGettingContractBranchesSuccess || state.ContractBranch?.successLoadingAll || false,
    failOnUpdating: state.ContractBranch?.failOnLoadingAll || false,
    failOnLoading: auxAddendum?.FailGettingContractBranches || state.ContractBranch?.failOnLoadingAll || false,
    error: auxAddendum?.ErrorGettingContractBranches || state.ContractBranch?.error,
    Contract: auxContract,
    ContractBranches: auxAddendum?.branches || [],
  }
};

export const mapDispatchToProps = {
    ...ContractBranchStore.actionCreators,
    ...ContractStore.actionCreators,
    ...ContractAddendumStore.actionCreators
};
